
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_13912_4670)","stroke":"#9DA7B2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1.182.808h1.404c.328 0 .643.121.876.338.232.216.362.51.362.816v8.077c0 .306-.13.599-.362.815a1.286 1.286 0 01-.876.338H1.182M9.975 8.885L13.07 6 9.975 3.115M12.328 6H6.755"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_13912_4670"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.316)","d":"M0 0h13.952v12H0z"}})])])])
          )
        }
      }
    